import React from "react";
import axios from "axios";
import { ArrowRight, Loader2 } from "lucide-react";
import { STATUS_CLS } from "@/components/GreenBallMatch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/tennis`;
const time = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : "");

export const GreenBallHomeTile = ({ onGo }) => {
  const [d, setD] = React.useState(null);
  React.useEffect(() => { axios.get(`${API}/card`).then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  const rows = (d?.rows || []).slice(0, 5);
  return (
    <section className="rounded-xl border border-lime-900/50 bg-[#0B0F17] p-4 lg:col-span-2" data-testid="home-tennis">
      <div className="mb-3 flex items-center justify-between">
        <p className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wide text-slate-100">🎾 Green Ball · today's top tennis picks</p>
        <button onClick={() => onGo("tennis")} data-testid="home-tennis-link" className="flex min-h-[36px] items-center gap-1 rounded-lg px-2 font-mono text-[11px] font-bold uppercase text-lime-300 transition-colors hover:bg-lime-950/40">
          Open Green Ball <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </div>
      {!d ? <div className="flex items-center gap-2 py-4 font-mono text-[11px] text-slate-500"><Loader2 className="h-4 w-4 animate-spin text-lime-400" /> Loading ATP / WTA card…</div>
        : d.error ? <p className="py-4 text-center font-mono text-[11px] text-rose-400">Tennis card unavailable.</p>
        : !rows.length ? <p className="py-4 text-center font-mono text-[11px] text-slate-600" data-testid="home-tennis-empty">No upcoming ATP / WTA singles matches today.</p> : (
        <>
          <div className="mb-2 flex flex-wrap gap-1.5 font-mono text-[10px]">
            {Object.entries(d.counts).map(([k, v]) => <span key={k} className={`rounded px-1.5 py-0.5 font-bold ${STATUS_CLS[k]}`}>{k} {v}</span>)}
          </div>
          <div className="grid gap-1.5 md:grid-cols-2">
            {rows.map((m) => (
              <button key={m.id} type="button" onClick={() => onGo("tennis")} data-testid={`home-tennis-row-${m.id}`}
                className="flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2 text-left transition-colors hover:border-lime-700/60">
                <span className={`rounded px-1.5 py-0.5 font-mono text-[9px] font-bold ${STATUS_CLS[m.eval.status]}`}>{m.eval.status === "DATA UNAVAILABLE" ? "NO DATA" : m.eval.status}</span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-[12px] font-bold text-lime-200">{m.eval.pick} · {Math.round(m.eval.prob * 100)}%</span>
                  <span className="block truncate font-mono text-[9px] text-slate-500">{m.players.map((p) => p.short).join(" vs ")} · {m.tour} {m.round} · {m.state === "pre" ? time(m.date) : "LIVE"}</span>
                </span>
                <span className="font-mono text-[9px] text-slate-500">TG {m.eval.totals.projection ?? "—"}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default GreenBallHomeTile;
